import { useContext } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import styles from './index.styl';
import UnityIdContext from 'core/components/UnityId';

function ramblerLogout() {
  if (!process.env.BROWSER_RUNTIME) return;

  window.ramblerIdHelper.logout();
}

const Logout = ({ className, children }, { features }) => {
  const { enableUnityId } = features;
  const { signOut } = useContext(UnityIdContext);

  return (
    <span
      onClick={enableUnityId ? signOut : ramblerLogout}
      className={cx(styles.logout, className)}
    >
      {children}
    </span>
  );
};

Logout.contextTypes = {
  features: PropTypes.shape({
    enableUnityId: PropTypes.bool,
  }),
};

Logout.propTypes = {
  /** Имя класса для стилизации */
  className: PropTypes.string,

  /** Содержимое, которое будет отрендерено компонентом */
  children: PropTypes.node,
};

Logout.defaultProps = {
  children: 'Выйти',
};

export default Logout;
